import { Box, Flex, Text } from '@fullstory/components';
import { ResourceCacheButton } from '../../components/ResourceCacheButton';
import { QueryCacheOptions } from '@fullstory/proto/fs/services/alexa';
import React, { PropsWithChildren } from 'react';

type ResourceCacheButtonProps = Pick<
  React.ComponentProps<typeof ResourceCacheButton>,
  'hovered' | 'timestamp' | 'status' | 'onCacheSwap' | 'onRefresh'
>;

interface DetailViewVisualizationHeaderProps extends ResourceCacheButtonProps {
  cacheOptionsRefresh: QueryCacheOptions;
  disablePadding?: boolean;
  title?: string;
}

export const DetailViewVisualizationHeader: React.FC<
  PropsWithChildren<DetailViewVisualizationHeaderProps>
> = ({ cacheOptionsRefresh, title, children, disablePadding = false, ...rest }) => (
  <Box data-component="DetailViewVisualizationHeader" padding={disablePadding ? 0 : 16}>
    <Flex justifyContent="space-between">
      <Flex justifyContent="flex-start" gap={16}>
        {title && (
          <Box marginLeft={8}>
            <Text appearance="bodyMedium" color="default">
              {title}
            </Text>
          </Box>
        )}
        <ResourceCacheButton {...rest} refreshableAfter={cacheOptionsRefresh.getIfAgeLessThan} />
      </Flex>
      <Box display="flex" alignItems="center" justifyContent="center" marginRight={8} gap={8}>
        {children}
      </Box>
    </Flex>
  </Box>
);
